import React from "react";
import { Navigate } from "react-router-dom";
import PropTypes from "prop-types";

function ProtectedRoute({ children }) {
  const isAuthenticated = !!localStorage.getItem("access_token"); // Check if the user is logged in

  return isAuthenticated ? children : <Navigate to="/authentication/sign-in" />;
}

// Add PropTypes validation
ProtectedRoute.propTypes = {
  children: PropTypes.node.isRequired,
};

export default ProtectedRoute;
